/**
 * Copyright © 2026 Adnuntius AS.
 */
import {InjectionToken} from '@angular/core';

import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {formatAdnStat} from './format-adn-stat';
import {AppLocaleService} from '../locale/app-locale.service';

export type AdnStatFilterFn = (
  stat: any,
  field?: any,
  fractionSize?: any,
  objId?: any
) => any;

export const ADN_STAT_FILTER = new InjectionToken<AdnStatFilterFn>('AdnStatFilter');

export function createAdnStatFilter(
  localNetworkProfile: LocalNetworkProfile,
  appLocale: AppLocaleService
): AdnStatFilterFn {
  return (stat: any, field?: any, fractionSize?: any, objId?: any) => {
    return formatAdnStat(
      stat,
      field,
      fractionSize,
      objId,
      localNetworkProfile.get('defaultCurrency'),
      appLocale.getLocaleId()
    );
  };
}

export const adnStatFilterProvider = {
  provide: ADN_STAT_FILTER,
  useFactory: createAdnStatFilter,
  deps: [LocalNetworkProfile, AppLocaleService]
};

